import Link from 'next/link';
import Button from "../ui/Button";
import type { HeroSection as HeroSectionType } from '@shared/lib/page-sections/types';

const HEIGHT: Record<NonNullable<HeroSectionType['height']>, string> = {
  sm: 'min-h-[260px] md:min-h-[320px]',
  md: 'min-h-[400px] md:min-h-[480px]',
  lg: 'min-h-[520px] md:min-h-[640px]',
};

const ALIGN: Record<NonNullable<HeroSectionType['align']>, string> = {
  left: 'items-start text-left',
  center: 'items-center text-center',
  right: 'items-end text-right',
};

export default function HeroSection({ section }: { section: HeroSectionType }) {
  const overlay = Math.max(0, Math.min(100, section.overlayPercent ?? (section.imageUrl ? 35 : 0)));
  const heightClass = HEIGHT[section.height ?? 'md'];
  const alignClass = ALIGN[section.align ?? 'center'];

  return (
    <section className={`relative w-full overflow-hidden ${heightClass}`}>
      {section.imageUrl ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={section.imageUrl}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 to-slate-700" />
      )}
      {overlay > 0 ? (
        <div
          className="absolute inset-0 bg-black"
          style={{ opacity: overlay / 100 }}
          aria-hidden="true"
        />
      ) : null}
      <div className={`relative flex h-full flex-col justify-center px-6 py-12 md:px-12 ${alignClass}`}>
        <div className="mx-auto max-w-3xl">
          <h1 className="text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl">
            {section.headline}
          </h1>
          {section.subheadline ? (
            <p className="mt-4 text-base text-white/85 sm:text-lg md:text-xl">
              {section.subheadline}
            </p>
          ) : null}
          {section.ctaLabel && section.ctaHref ? (
            <div className="mt-6">
              <Button asChild variant="primary" size="lg">
          <Link href={section.ctaHref}>
                {section.ctaLabel}
              </Link>
        </Button>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
